
import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: "ri-car-line",
      title: t('why.luxury.title'),
      description: t('why.luxury.desc')
    },
    {
      icon: "ri-24-hours-line",
      title: t('why.service.title'),
      description: t('why.service.desc')
    },
    {
      icon: "ri-shield-check-line",
      title: t('why.professional.title'),
      description: t('why.professional.desc')
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: t('why.competitive.title'),
      description: t('why.competitive.desc')
    }
  ];

  return (
    <section id="about" className="py-12 sm:py-16 lg:py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">
            {t('why.title')}
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto px-4">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group p-4">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:bg-yellow-300 transition-colors">
                <i className={`${feature.icon} text-2xl sm:text-3xl text-black`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">{feature.title}</h3>
              <p className="text-sm sm:text-base text-gray-300 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
